import React, { useCallback } from 'react';
import { transformHTMLParserLinks } from '../../../../../../../utils/rewriteLink/rewriteLink';
import SlideDown from '../../../../../../SlideDown/SlideDown';
import { namesAndIds } from '../../../../../../../types/shared/PrequalificationDataEntry';
import { usePersonalInformation } from '../../../../../providers/PersonalInformationProvider';
import { usePageProperties } from '../../../../../providers/PagePropertiesProvider';
import { usePersonalInformationError } from '../../../../../providers/PersonalInformationErrorProvider';
import useValidOnFocus from '../../hooks/useValidOnFocus';
import { isDateValid } from '../../../../../../../utils/acquisition-utils';
import StateField from '../../../../../../FieldContainers/AddressFields/StateField/StateField';
import { generateFieldErrorMessage } from '../../../../../../../utils/error-message';
import { TAddressInputProps } from '../../Inputs.types';

export type TStateDropdownInputProps = Pick<TAddressInputProps, 'addressValidationCheck'> & {
        onKeyDown: (e: React.KeyboardEvent) => void;
        isPrefill?: boolean;
        orangeAsterisksOnMobile?: boolean;
        disabled?: boolean;
    };

export default function StateDropdownInput({ addressValidationCheck, onKeyDown, isPrefill, orangeAsterisksOnMobile, disabled = false }: TStateDropdownInputProps): JSX.Element {
    const { wiResidentDisclaimerText } = usePageProperties();
    const {
        personalInformation: { dob, MailingState },
        setSingleValue,
    } = usePersonalInformation();
    const {
        personalInformationError: {
            MailingState: { required, isInError, isValidValue, message },
        },
        dispatch,
    } = usePersonalInformationError();

    
    const setValid = useCallback((isValid: boolean) => {
        dispatch({
            type: 'setValid',
            target: 'MailingState',
            payload: isValid,
        });
    }, []);

    const { setValidOnFocus } = useValidOnFocus(isInError, setValid);


    const setDOBValid = useCallback((isValid: boolean) => {
        dispatch({
            type: 'setValid',
            target: 'dob',
            payload: isValid,
        });
    }, []);

    const handleBlur = () => {
        addressValidationCheck();
        if (dob.length === 10) {
            const dateValid = isDateValid(dob, MailingState);
            setDOBValid(dateValid);
        }
    };

    const handleState = (val: string) => {
        setValidOnFocus();
        setSingleValue('MailingState')(val);
    };


    return (
        <div>
            <StateField
                {...namesAndIds.MailingState}
                value={MailingState}
                setValueCallback={(val) => handleState(val)}
                placeholder='Select a State'
                alternate
                mixed
                required={required}
                valid={[isValidValue, setValid]}
                error={isInError}
                errorText={generateFieldErrorMessage('State', 'missingValue')}
                invalidErrorMessage={generateFieldErrorMessage('State', 'missingValue')}
                requiredMessage={generateFieldErrorMessage('State', 'missingValue')}
                onBlurCallback={handleBlur}
                onKeyDownCallback={onKeyDown}
                disabled={disabled}
                useOutsideValidation={isValidValue}
                useSuccessIcon
                showSuccessIcon={disabled || undefined}
                isPrefill={isPrefill}
                orangeAsterisksOnMobile={orangeAsterisksOnMobile}
            />
        <SlideDown
            className='PqDataEntryForm__main--disclaimer'
            open={MailingState === 'WI'}
        >
            {transformHTMLParserLinks(wiResidentDisclaimerText)}
        </SlideDown>
        </div>
    );
}
